/*
 * @Author: MX
 * @Date: 2021-03-26 15:54:15
 * @Description:
 */
import lang from 'element-ui/lib/locale/lang/th' // 引入element语言包-泰语
const messages = {
  message: {
    'text': 'Good good study, Day day up',
  },
  ...lang,
}

export default messages
